import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "publish h-[500px] relative"
};
const _hoisted_2 = {
  class: "flex flex-wrap gap-2 mt-4"
};
const _hoisted_3 = {
  class: "absolute bottom-4 w-full text-center"
};
import { ref, inject } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { cloneDeep } from 'lodash';
import ConfirmWord from './components/ConfirmWord.vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'PublishPlan'
  },
  __name: 'PublishPlan',
  setup(__props) {
    const openSidePreview = inject('openSidePreview');
    const activeTab = ref(2);
    const isSubmitting = ref(false);
    const tabOptions = ref([{
      label: '权威媒体',
      value: 2,
      productID: 14,
      component: 'Tab1',
      userInfo: {}
    }, {
      label: '臻选媒体',
      value: 3,
      productID: 46,
      component: 'Tab2',
      userInfo: {}
    }, {
      label: '自媒体',
      value: 6,
      productID: 222,
      component: 'Tab2',
      userInfo: {}
    }, {
      label: '联盟新闻',
      value: 4,
      component: 'Tab3',
      userInfo: {}
    }]);
    // 统一的可用文件列表
    const availableFiles = ref([{
      fileName: 'geo.txt',
      knowledgeId: '1',
      filePath: 'https://preapiconsole.71360.com/w3/k4vde5/20250610/aba3f27c6e7846e528bce9defb08c718.txt'
    }, {
      fileName: '文件2.txt',
      knowledgeId: '2',
      filePath: 'https://preapiconsole.71360.com/w3/k4vde5/20250610/aba3f27c6e7846e528bce9defb08c718.txt'
    }]);
    // 表单数据存储
    const formData = ref({
      Tab1: {
        mediaList: [{
          title: '媒体1',
          itemID: '1'
        }],
        checkedFiles: cloneDeep(availableFiles)
      },
      Tab2: {
        mediaList: [{
          title: '媒体2',
          itemID: '2'
        }],
        checkedFiles: cloneDeep(availableFiles)
      },
      Tab3: {
        mediaList: [{
          title: '媒体3',
          itemID: '3'
        }],
        checkedFiles: cloneDeep(availableFiles)
      }
    });
    // Tab 切换处理
    const handleTabChange = async tabName => {
      activeTab.value = tabName;
    };
    // 获取当前组件名称
    const getCurrentTabKey = () => {
      return tabOptions.value.find(item => item.value === activeTab.value)?.component;
    };
    const isChecked = knowledgeId => {
      return formData.value[getCurrentTabKey()].checkedFiles.some(item => item.knowledgeId === knowledgeId);
    };
    // 统一提交所有表单数据
    const handleSubmit = async () => {
      try {
        isSubmitting.value = true;
        console.log(formData.value, 'formData');
        ElMessage.success('发布成功！');
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('发布失败，请重试');
        }
      } finally {
        isSubmitting.value = false;
      }
    };
    const beforeSubmit = () => {
      ElMessageBox.confirm('确认发布计划后将会立即按照发布计划进行发布操作，是否继续？', '是否确认执行当前发布计划？', {
        confirmButtonText: '立即执行',
        cancelButtonText: '先不执行',
        type: 'warning'
      }).then(() => {
        handleSubmit();
      });
    };
    const handleModify = () => {};
    const handleClick = son => {
      const currentTabKey = getCurrentTabKey();
      if (isChecked(son.knowledgeId)) {
        formData.value[currentTabKey].checkedFiles = formData.value[currentTabKey].checkedFiles.filter(item => item.knowledgeId !== son.knowledgeId);
      } else {
        formData.value[currentTabKey].checkedFiles.push(son);
      }
    };
    const handleClickFull = son => {
      openSidePreview({
        url: son.filePath,
        title: son.fileName
      });
    };
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("h4", {
        class: "font-bold mt-4"
      }, "本次已选以下媒体", -1)), _createVNode(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        onTabChange: handleTabChange,
        class: "w-full h-[200px]"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.value,
            label: item.label,
            name: item.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value[item.component].mediaList, item => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: item.itemID
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createElementVNode("h4", {
        class: "font-bold mt-4"
      }, "已选语料库", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFiles.value, son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.knowledgeId,
          disabled: false,
          name: son.fileName,
          checked: isChecked(son.knowledgeId),
          onClick: $event => handleClick(son),
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["name", "checked", "onClick", "onClickFull"]);
      }), 128))]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        type: "primary",
        loading: isSubmitting.value,
        onClick: beforeSubmit
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 确认发布计划 ", -1)]))]),
        _: 1
      }, 8, ["loading"]), _createVNode(_component_el_button, {
        type: "info",
        text: "",
        bg: "",
        loading: isSubmitting.value,
        onClick: handleModify
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 修改发布计划 ", -1)]))]),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});